"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _confirmation_pane = _interopRequireDefault(require("./confirmation_pane"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var svg = /*#__PURE__*/_react.default.createElement("svg", {
  focusable: "false",
  width: "56px",
  height: "56px",
  viewBox: "0 0 52 52",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  className: "checkmark"
}, ' ', /*#__PURE__*/_react.default.createElement("circle", {
  cx: "26",
  cy: "26",
  r: "25",
  fill: "none",
  className: "checkmark__circle"
}), ' ', /*#__PURE__*/_react.default.createElement("path", {
  fill: "none",
  d: "M14.1 27.2l7.1 7.2 16.7-16.8",
  className: "checkmark__check"
}), ' ');
var SuccessPane = function SuccessPane(props) {
  return /*#__PURE__*/_react.default.createElement(_confirmation_pane.default, _extends({
    svg: svg
  }, props));
};
var _default = exports.default = SuccessPane;
